export default function formatTime(timeString) {
  const [hours, minutes] = timeString.split(':')
  const period = parseInt(hours, 10) < 12 ? 'am' : 'pm'
  let formattedHours = parseInt(hours, 10) % 12

  formattedHours = formattedHours === 0 ? 12 : formattedHours

  return `${formattedHours}:${minutes} ${period}`
}
